import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { LaddaModule } from 'angular2-ladda';
import { TranslateModule } from "@ngx-translate/core";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { EquipmentRoutingModule } from './equipment-routing.module';
import { TelephonyMainComponent } from './containers/telephony-main/telephony-main.component';
import { EquipmentFiltersComponent } from './components/equipment-filters/equipment-filters.component';
import { EquipmentTableComponent } from './components/equipment-table/equipment-table.component';
import { SingleEquipmentComponent } from './containers/single-equipment/single-equipment.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AddEquipmentPopupComponent } from './components/add-equipment-popup/add-equipment-popup.component';
import { SelectModelComponent } from './components/select-model/select-model.component';
import { SingleEquipmentTableComponent } from './components/single-equipment-table/single-equipment-table.component';
import { SingleEquipmentAirSectionComponent } from './components/single-equipment-air-section/single-equipment-air-section.component';
import { SingleEquipmentProvisioningComponent } from './components/single-equipment-provisioning/single-equipment-provisioning.component';
import { AllocateToPbxPopupComponent } from './components/allocate-to-pbx-popup/allocate-to-pbx-popup.component';
import { AssignToUserPopupComponent } from './components/assign-to-user-popup/assign-to-user-popup.component';
import { AddHandsetPopupComponent } from './components/add-handset-popup/add-handset-popup.component';
import { ChangeOutboundDidPopupComponent } from './components/change-outbound-did-popup/change-outbound-did-popup.component';
import { EquipmentMainComponent } from './containers/equipment-main/equipment-main.component';
import { ConnectivityMainComponent } from './containers/connectivity-main/connectivity-main.component';
import { ConnectivityFiltersComponent } from './components/connectivity-filters/connectivity-filters.component';
import { ConnectivityTableComponent } from './components/connectivity-table/connectivity-table.component';
import { EditConnectivityEntryComponent } from './components/edit-connectivity-entry/edit-connectivity-entry.component';
import { ConnectivityEntryFormComponent } from './components/connectivity-entry-form/connectivity-entry-form.component';
import { AddConnectivityEntryComponent } from './components/add-connectivity-entry/add-connectivity-entry.component';
import { ConnectivityEntrySearchComponent } from './components/connectivity-entry-search/connectivity-entry-search.component';
import { EditConnectivityEntryDocumentsComponent } from './components/edit-connectivity-entry-documents/edit-connectivity-entry-documents.component';

@NgModule({
    declarations: [
        TelephonyMainComponent,
        EquipmentFiltersComponent,
        SelectModelComponent,
        EquipmentTableComponent,
        SingleEquipmentComponent,
        SingleEquipmentTableComponent,
        SingleEquipmentAirSectionComponent,
        SingleEquipmentProvisioningComponent,
        AllocateToPbxPopupComponent,
        AssignToUserPopupComponent,
        AddHandsetPopupComponent,
        AddEquipmentPopupComponent,
        ChangeOutboundDidPopupComponent,
        EquipmentMainComponent,
        ConnectivityMainComponent,
        ConnectivityFiltersComponent,
        ConnectivityTableComponent,
        EditConnectivityEntryComponent,
        ConnectivityEntryFormComponent,
        AddConnectivityEntryComponent,
        ConnectivityEntrySearchComponent,
        EditConnectivityEntryDocumentsComponent
    ],
    imports: [
        NgbModule,
        EquipmentRoutingModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        NgxSkeletonLoaderModule,
        TranslateModule.forChild(),
        LaddaModule.forRoot({
            spinnerColor: 'grey',
            style: 'zoom-in'
        }),
        SharedModule
    ],
    exports: [
        TelephonyMainComponent,
        EquipmentTableComponent,
        EquipmentFiltersComponent,
        SingleEquipmentComponent,
        SingleEquipmentTableComponent,
        SingleEquipmentAirSectionComponent,
        SingleEquipmentProvisioningComponent,
        AllocateToPbxPopupComponent,
        AssignToUserPopupComponent,
        AddHandsetPopupComponent,
        AddEquipmentPopupComponent,
        ConnectivityEntrySearchComponent
    ]
})
export class EquipmentModule { }
